import { Playground } from 'docz';
import { Menu } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Menu,
  React
};